import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        context: '=',
        canManageCourse: '=',
        course: '='
    },
    template: `
        <div class="well type02">
            <div class="alert alert-plain" ng-if="!vm.form.model.activeCourseSkills || vm.form.model.activeCourseSkills.length === 0">
                <h3>{{ 'skill.No skills added' | translate }}</h3>
                <p ng-if="!vm.hasPublishedOccurrence">{{ 'skill.Please add some content' | translate }}</p>
            </div>
            <div ng-if="vm.form.model.activeCourseSkills && vm.form.model.activeCourseSkills.length > 0">
                <p>{{ 'skill.Completing this course will increase skill proficiency as follows' | translate }}:</p>
                <table class="data05">
                    <thead>
                        <tr>
                            <th>{{ 'skill.Skill' | translate }}</th>
                            <th>{{ 'skill.Proficiency' | translate }}</th>
                            <th class="w1p">&nbsp;</th>
                            <th class="w1p">&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="(key, item) in vm.form.model.activeCourseSkills">
                            <td>
                                <select class="form-control" style="width: 300px;"
                                    ng-class="{'has-error': vm.form.submitted && !item.skillId}"
                                    ng-change="vm.onScaleChanged(item)"
                                    ng-model="item.skillId"
                                    ng-disabled="vm.hasPublishedOccurrence"
                                    ng-options="skill.id as skill.name for skill in vm.availableSkills(key)">
                                        <option value="">{{ 'filter.Select' | translate }}</option>
                                </select>
                                <span class="text-danger" ng-if="vm.form.submitted && !item.skillId">{{ 'skill.Please select a skill' | translate }}</span>
                            </td>
                            <td>
                                <select class="form-control" style="width: 300px;"
                                    ng-class="{'has-error': vm.form.submitted && item.skillId && !item.proficiencyId}"
                                    ng-model="item.proficiencyId"
                                    ng-disabled="vm.hasPublishedOccurrence"
                                    ng-options="p.id as vm.proficiencyLabel(p) for p in vm.getProficienciesForSkill(item.skillId)">
                                        <option value="">{{ 'filter.Select' | translate }}</option>
                                </select>
                                <span class="text-danger" ng-if="vm.form.submitted && item.skillId && !item.proficiencyId">{{ 'skill.Please select a proficiency' | translate }}</span>
                            </td>
                            <td>
                                <a class="tooltip-icon" ng-click="vm.viewInfo(item)" ng-if="item.skillId && item.proficiencyId">i</a>
                            </td>
                            <td>
                                <a class="btn delete notext"
                                  ng-click="vm.remove(key)"
                                  ng-if="vm.canManageCourse && !vm.hasPublishedOccurrence && !vm.course.isArchived"> {{ 'skill.Delete' | translate }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ul class="actions01">
                <li>
                    <a class="btn bordered02" ng-click="vm.add()" ng-if="vm.canManageCourse && !vm.hasPublishedOccurrence && !vm.course.isArchived">{{ 'skill.Add skill' | translate }}</a>
                </li>
            </ul>
        </div>
    `
})

export default class {
    constructor ($scope, $translate, toastr, $timeout, lodash, ModalService, SkillScaleResource, CourseVersionService, SkillResource, CourseVersionResource, I18nService) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.$timeout = $timeout;
        this.ModalService = ModalService;
        this.CourseVersionService = CourseVersionService;
        this.SkillResource = SkillResource;
        this.CourseVersionResource = CourseVersionResource;
        this.I18nService = I18nService;
        this.SkillScaleResource = SkillScaleResource;
        this.loadingProficiencies = {};
        this.maxSkillsPerCourse = 10;
        this.error = '';
    }

    $onInit () {
        if (!this.form.model.activeCourseSkills) {
            this.form.model.activeCourseSkills = [];
        }

        // Normalize ids to string for consistent ng-options binding and handle snake_case -> camelCase
        this.normalizeCourseSkills();
        this.hasPublishedOccurrence = this.CourseVersionService.getPublishedOccurrenceCount(this.form.model);

        // Load all company skills for dropdown and map of proficiencies
        this.skills = [];
        this.proficienciesMap = {};
        this.proficiencies = [];
        this.proficiencyNames = {};
        this.courseSkillExplanations = {};

        this.initSkillAndProficiencies();
    }

    normalizeCourseSkills () {
        this.lodash.forEach(this.form.model.activeCourseSkills, (cs) => {
            if (!cs) return;

            if (cs.skillId === undefined && cs.skill_id !== undefined) {
                cs.skillId = cs.skill_id;
            }

            cs.skillId = cs.skillId !== null && cs.skillId !== undefined ? parseInt(cs.skillId, 10) : null;
            if (cs.proficiencyId !== undefined) {
                cs.proficiencyId = parseInt(cs.proficiencyId, 10);
            }
        });
    }

    availableSkills (index) {
        const all = this.skills || [];
        const courseSkills = this.form.model && Array.isArray(this.form.model.activeCourseSkills)
            ? this.form.model.activeCourseSkills : [];
        const selected = new Set();
        courseSkills.forEach((cs, i) => {
            if (!cs) return;
            if (i === index) return; // ignore current row
            const sid = cs && cs.skillId;
            if (sid) selected.add(parseInt(sid, 10));
        });
        const currentId = courseSkills[index] && courseSkills[index].skillId ? parseInt(courseSkills[index].skillId, 10) : null;
        return all.filter(s => {
            const sid = parseInt(s.id, 10);
            // allow current selection even if it is selected in another row
            return sid === currentId || !selected.has(sid);
        });
    }

    isSkillActive (skillId) {
        if (!skillId) return true;
        const all = this.skills || [];
        const id = parseInt(skillId, 10);
        return all.some(s => parseInt(s.id, 10) === id);
    }

    ensureProficienciesForSkill (skillId) {
        const key = parseInt(skillId, 10);
        if (!key) return Promise.resolve([]);

        if (this.proficienciesMap[key] && this.proficienciesMap[key].length && this.courseSkillExplanations[key]) {
            return Promise.resolve(this.courseSkillExplanations[key]);
        }
        if (this.loadingProficiencies[key]) {
            return this.loadingProficiencies[key];
        }

        if (this.SkillResource.get) {
            const params = {
                id: key,
                is_active: 1,
                expand: 'i18ns,activeI18n,scale.activeI18n,scale.scaleI18ns,scale.proficiencies.skillProficiencyI18n,scale.proficiency.activeI18n,explanations.i18ns,' +
                    'explanations.proficiency.activeI18n'
            };
            const p = this.SkillResource.get(params).$promise.then((s) => {
                // getting skill's selected language to show explanations in that language
                const lang = this.getPreferredLanguage(s.scale && s.scale.scaleI18ns);
                const profs = (s.scale && s.scale.proficiencies) ? s.scale.proficiencies : [];
                this.proficienciesMap[key] = profs.map(pr => ({
                    id: (pr.id) ? parseInt(pr.id, 10) : null,
                    name: (pr.skillProficiencyI18n && pr.skillProficiencyI18n[lang]) ? pr.skillProficiencyI18n[lang].value : '',
                    points: pr.points !== undefined ? pr.points : 0
                }));

                /** preparing skill explanations for each proficiency*/
                const explanations = Array.isArray(s.explanations) ? s.explanations : [];
                const profList = this.proficienciesMap[key] || [];
                this.courseSkillExplanations[key] = profList.map((prof) => {
                    const matchingExplanation = explanations.find(e => parseInt(e.proficiencyId, 10) === parseInt(prof.id, 10));
                    const expVal = matchingExplanation && matchingExplanation.i18ns && matchingExplanation.i18ns[lang] && matchingExplanation.i18ns[lang].value;
                    return {
                        proficiencyName: prof.name || '',
                        skillExplanationValue: expVal || '',
                        proficiencyPoints: prof.points || 0
                    };
                }).sort((a, b) => a.proficiencyPoints - b.proficiencyPoints);
                return this.courseSkillExplanations[key] || [];
            }).finally(() => {
                delete this.loadingProficiencies[key];
            });
            this.loadingProficiencies[key] = p;
            return p;
        }
        return Promise.resolve(this.courseSkillExplanations[key] || []);
    }

    initSkillAndProficiencies () {
        const skillParams = {
            pageSize: 0,
            is_active: 1,
            expand: 'i18ns,activeI18n,scale.activeI18n,scale.scaleI18ns,scale.proficiencies.skillProficiencyI18n,explanations.i18ns,explanations.proficiency.activeI18n'
        };

        if (this.SkillResource.query) {
            this.SkillResource.query(skillParams).$promise.then((skills) => {
                this.skills = skills.map(s => ({
                    id: parseInt(s.id, 10),
                    name: (s.activeI18n && s.activeI18n.name) || ''
                }));

                // Remove courseSkills where the skill is not active
                const activeSkillIds = new Set(this.skills.map(s => s.id));
                this.form.model.activeCourseSkills = (this.form.model.activeCourseSkills || []).filter(cs => {
                    if (!cs || !cs.skillId) return true; // Keep empty entries for new additions
                    return activeSkillIds.has(parseInt(cs.skillId, 10));
                });

                skills.forEach((s) => {
                    const lang = this.getPreferredLanguage(s.scale && s.scale.scaleI18ns);
                    const key = parseInt(s.id, 10);

                    const profs = (s.scale && s.scale.proficiencies) ? s.scale.proficiencies : [];
                    this.proficienciesMap[key] = profs.map(p => ({
                        id: (p.id) ? parseInt(p.id, 10) : null,
                        name: (p.skillProficiencyI18n && p.skillProficiencyI18n[lang]) ? p.skillProficiencyI18n[lang].value : '',
                        points: p.points !== undefined ? p.points : 0
                    }));

                    const explanations = Array.isArray(s.explanations) ? s.explanations : [];
                    const profList = this.proficienciesMap[key] || [];
                    this.courseSkillExplanations[key] = profList.map((prof) => {
                        const matchingExplanation = explanations.find(e => parseInt(e.proficiencyId, 10) === parseInt(prof.id, 10));
                        let expVal = '';
                        if (matchingExplanation && matchingExplanation.i18ns) {
                            const expLang = this.getPreferredLanguage(s.i18ns);
                            expVal = matchingExplanation.i18ns[expLang] && matchingExplanation.i18ns[expLang].value || '';
                        }
                        return {
                            proficiencyName: prof.name || '',
                            skillExplanationValue: expVal,
                            proficiencyPoints: prof.points || 0
                        };
                    }).sort((a, b) => a.proficiencyPoints - b.proficiencyPoints);
                });

                // Load scale and proficiencies for the first saved course skill on page load
                const courseSkills = this.form.model.activeCourseSkills || [];
                if (courseSkills.length > 0 && courseSkills[0] && courseSkills[0].skillId) {
                    const firstSkillId = parseInt(courseSkills[0].skillId, 10);
                    const firstSkill = this.skills.find(s => s.id === firstSkillId);
                    if (firstSkill && firstSkill.scaleId) {
                        this.loadScaleAndProficiencies(firstSkill.scaleId);
                    }
                }
            });
        }
    }

    add () {
        if (this.availableSkills().length === 0) {
            this.toastr.error(this.$translate.instant('skill.noMoreSkillsAvailable'));
            return;
        }
        if (this.form.model.activeCourseSkills.length >= this.maxSkillsPerCourse) {
            this.toastr.error(this.$translate.instant('skill.maxSkillsLimit', { count: this.maxSkillsPerCourse }));
            return;
        }
        this.form.model.activeCourseSkills.push({});
    }

    remove (index) {
        const message = this.$translate.instant('skill.Are you sure you wish to remove the skill?');
        this.ModalService.confirm(message).then(() => {
            const cs = this.form.model.activeCourseSkills[index];
            if (!cs.id) {
                this.form.model.activeCourseSkills.splice(index, 1);
                return;
            }

            if (this.form.model.activeCourseSkills.length > 1) {
                this.form.model.activeCourseSkills.splice(index, 1);
            }
            else {
                this.form.model.activeCourseSkills = [];
            }
        });
    }

    viewInfo (item) {
        const skillId = item && item.skillId ? parseInt(item.skillId, 10) : null;
        const selected = (this.skills || []).find(s => parseInt(s.id, 10) === skillId);
        const skillName = (selected && selected.name) || '';
        return Promise.resolve(this.ensureProficienciesForSkill(skillId)).then((explanations) => {
            return this.ModalService.open({
                size: 'drawer',
                windowClass: 'drawer-modal',
                backdropClass: 'drawer-backdrop',
                animation: true,
                backdrop: true,
                template: `
                    <modals-user-skills-proficiency
                        uib-modal-instance="vm.$uibModalInstance"
                        explanations="vm.explanations"
                        skill-name="vm.skillName"
                        class="wrapper">
                    </modals-user-skills-proficiency>
            `,
                controller: this.createDrawerModalController(explanations, skillName)
            });
        }).catch(() => {});
    }

    createDrawerModalController (explanations, skillName) {
        return [
            '$scope', '$document', '$uibModalInstance', '$timeout',
            function ($scope, $document, $uibModalInstance, $timeout) {
                this.explanations = explanations;
                this.skillName = skillName;
                this.$uibModalInstance = $uibModalInstance;
                // expose buttons
                this.ok = () => $uibModalInstance.close();
                this.cancel = () => $uibModalInstance.dismiss('cancel');

                let closing = false;
                let dialog = null;
                let backdrop = null;

                // Wait until the modal is in the DOM, then capture *this* instance's elements
                $uibModalInstance.rendered.then(() => {
                    // pick the most recently added modal with our custom class
                    const modals = $document[0].querySelectorAll('.modal.drawer-modal');
                    const modalEl = modals[modals.length - 1];
                    if (modalEl) {
                        dialog = modalEl.querySelector('.modal-dialog');
                    }
                    const backs = $document[0].querySelectorAll('.modal-backdrop.drawer-backdrop');
                    backdrop = backs[backs.length - 1] || null;
                });

                // Intercept all close paths (OK, cancel, ESC, backdrop)
                $scope.$on('modal.closing', (event, resultOrReason, closed) => {
                    if (closing) return;
                    event.preventDefault(); // keep it in DOM while animating out
                    closing = true;
                    if (dialog) dialog.classList.add('slide-out');
                    if (backdrop) backdrop.classList.add('closing');

                    const finish = () => {
                        if (dialog) dialog.removeEventListener('animationend', finish);
                        if (backdrop) backdrop.removeEventListener('transitionend', finish);
                        if (closed) $uibModalInstance.close(resultOrReason);
                        else $uibModalInstance.dismiss(resultOrReason);
                    };

                    if (dialog) dialog.addEventListener('animationend', finish, { once: true });
                    if (backdrop) backdrop.addEventListener('transitionend', finish, { once: true });

                    // Safety net in case events don't fire
                    $timeout(finish, 500000);
                });
            }
        ];
    }

    getPreferredLanguage (i18ns) {
        const i18n = this.I18nService.getPreferredI18n(i18ns || {});
        return i18n ? i18n.language : null;
    }

    getProficiencyName (proficiencyId) {
        const i18ns = this.proficiencyNames[proficiencyId] || {};

        const i18n = this.I18nService.getPreferredI18n(i18ns);
        if (i18n && i18n.value) {
            return i18n.value;
        }

        // Fallback to empty string if no name found
        return '';
    }

    proficiencyLabel (p) {
        const no = (typeof p.points === 'number') ? p.points : (p.order_no || p.id);
        const nm = (p.name) ? p.name : this.getProficiencyName(p.id);

        return `${no} - ${nm}`;
    }

    getProficienciesForSkill (skillId) {
        const key = parseInt(skillId, 10);
        if (!key) return [];
        return this.proficienciesMap[key] || [];
    }

    onScaleChanged (item) {
        const skillId = item && item.skillId ? parseInt(item.skillId, 10) : null;
        const selectedSkill = (this.skills || []).find(s => s.id === skillId);
        const scaleId = selectedSkill ? selectedSkill.scaleId : null;
        if (scaleId && skillId) {
            this.loadScaleAndProficienciesForSkill(scaleId, skillId);
        }
        // Reset proficiencyId when skill changes
        if (item) {
            item.proficiencyId = null;
        }
    }

    loadScaleAndProficiencies (scaleId) {
        const params = { id: scaleId, expand: 'activeI18n,scaleI18ns,proficiencies.skillProficiencyI18n' };
        return this.SkillScaleResource.get(params).$promise.then((scale) => {
            const profs = Array.isArray(scale && scale.proficiencies) ? scale.proficiencies : [];

            // Get enabled languages from the scale
            const enabledLanguages = {};
            if (scale.scaleI18ns) {
                Object.keys(scale.scaleI18ns).forEach(lang => {
                    const i18n = scale.scaleI18ns[lang];
                    if (i18n && i18n.isEnabled) {
                        enabledLanguages[lang] = true;
                    }
                });
            }

            this.proficiencyNames = {};
            (profs || []).forEach(p => {
                // Filter proficiency translations to only include enabled languages
                const filteredI18ns = {};
                const allI18ns = p.skillProficiencyI18n || {};
                Object.keys(allI18ns).forEach(lang => {
                    if (enabledLanguages[lang]) {
                        filteredI18ns[lang] = allI18ns[lang];
                    }
                });
                this.proficiencyNames[p.id] = filteredI18ns;
            });
            return scale;
        });
    }

    loadScaleAndProficienciesForSkill (scaleId, skillId) {
        const params = { id: scaleId, expand: 'activeI18n,scaleI18ns,proficiencies.skillProficiencyI18n' };
        const digest = (fn) => (this.$timeout ? this.$timeout(fn, 0) : fn());
        const key = parseInt(skillId, 10);

        return this.SkillScaleResource.get(params).$promise.then((scale) => {
            const profs = Array.isArray(scale && scale.proficiencies) ? scale.proficiencies : [];

            // Get enabled languages from the scale
            const enabledLanguages = {};
            if (scale.scaleI18ns) {
                Object.keys(scale.scaleI18ns).forEach(lang => {
                    const i18n = scale.scaleI18ns[lang];
                    if (i18n && i18n.isEnabled) {
                        enabledLanguages[lang] = true;
                    }
                });
            }

            (profs || []).forEach(p => {
                // Filter proficiency translations to only include enabled languages
                const filteredI18ns = {};
                const allI18ns = p.skillProficiencyI18n || {};
                Object.keys(allI18ns).forEach(lang => {
                    if (enabledLanguages[lang]) {
                        filteredI18ns[lang] = allI18ns[lang];
                    }
                });
                this.proficiencyNames[p.id] = filteredI18ns;
            });

            const options = profs.map(p => ({
                id: p.id,
                points: (typeof p.points === 'number') ? p.points : (p.order_no || p.id),
                name: this.getProficiencyName(p.id)
            })).sort((a, b) => (a.points === b.points ? a.id - b.id : a.points - b.points));

            digest(() => {
                this.proficienciesMap[key] = options;
            });

            return scale;
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/skills/index.js